import { get } from "@/lib/fetcher";

export const getCandidateCV = async (candidateId) => {
  return await get(`/admin/candidates/${candidateId}/cv`);
};